import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import { Action } from 'src/app/shared/models/action';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-edit-action',
  templateUrl: './edit-action.component.html',
  styleUrl: './edit-action.component.scss'
})


export class EditActionComponent {

  item: Action = new Action();
  items: any;
  programmeData: any = []
  agenceData: any = [];
  resultatItems: any = [];
  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private FecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,

  ) { }


  ngOnInit() {

    this.item = this.localstorage.getAction();
    this.items = this.localstorage.getAction();

    this.fetchDataPrograme();
    if (this.items?.date_debut) {
      const date = new Date(this.items.date_debut);
      const annee = date.getFullYear();
      const mois = String(date.getMonth() + 1).padStart(2, '0');
      const jour = String(date.getDate()).padStart(2, '0');

      this.item.date_debut = `${annee}-${mois}-${jour}`;
    }
    if (this.items?.date_fin) {
      const date = new Date(this.items.date_fin);
      const annee = date.getFullYear();
      const mois = String(date.getMonth() + 1).padStart(2, '0');
      const jour = String(date.getDate()).padStart(2, '0');

      this.item.date_fin = `${annee}-${mois}-${jour}`;
    }
  }

  close() {

    this.modalService.dismissAll();
  }


  EditAction() {

    const item = this.localstorage.getAction();
    this.ngxService.start();

    this.item.programme_id = this.item.programme_id.id;
    this.paramService.editAction(item.reference, this.item).subscribe(
      (response: any) => {
        ////console.log("la reponse du webservice",response);
        this.ngxService.stop();

        this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.FecthDataService.notifySeriviceCreated();

      },
      (error: any) => {
        const errorMessage = error?.error?.message
            || error?.error?.error
            || error?.message
            || 'Une erreur est survenue';
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: errorMessage });
        this.modalService.dismissAll();
        this.ngxService.stop();

      }
    )
  }

   onProgrammeChange(event: any) {
    const programmeId = event.target.value;
        console.log("programmeId",programmeId);

    if (programmeId) {
      this.getResultatByProgramme(programmeId);
    } else {
      this.resultatItems = [];
      this.item.resultat = null;
    }
  }
  fetchDataPrograme() {


    this.paramService.fetchDataPrograme().subscribe(

      (response: any) => {

        this.programmeData = response.data;
        this.item.programme_id = this.programmeData.find(
          (p: any) => p.id === this.items?.programme?.id
        );
        ////console.log("this.programmeData",this.programmeData);
      },
      (error) => {
        ////console.log("une erreur est survenu",error);

      }

    );
  }

  getResultatByProgramme(programmeId: any) {
    this.paramService.getResultatByProgramme(programmeId).subscribe(
      (response: any) => {
        //console.log("Résultats par programme:", response);
        this.resultatItems = response.data || [];
      },
      (error: any) => {
        //console.log("Erreur lors de la récupération des résultats:", error);
        this.resultatItems = [];
      }
    );
  }
  onSelectProgramme() {

    this.item.code = this.item.programme_id.code + '.'
  }


}
